import { useEffect, type ReactNode } from 'react';
import './cheques.css';

interface ModalProps {
  readonly title: string;
  readonly onClose: () => void;
  readonly maxWidth?: number | undefined;
  readonly children: ReactNode;
  readonly testId?: string | undefined;
}

export function ChequeModal({ title, onClose, maxWidth, children, testId }: ModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="chq-overlay">
      <div
        className="chq-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        data-testid={testId}
        style={maxWidth ? { maxWidth } : undefined}
      >
        <div className="chq-dialog-head">
          <h2>{title}</h2>
          <button type="button" className="chq-close" onClick={onClose} aria-label="بستن">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

interface FieldProps {
  readonly id: string;
  readonly label: string;
  readonly required?: boolean | undefined;
  readonly ai?: boolean | undefined;
  readonly children: ReactNode;
}

export function ChequeField({ id, label, required, ai, children }: FieldProps) {
  return (
    <div className="chq-field">
      <label htmlFor={id}>
        {label}
        {required ? ' *' : ''}
        {ai ? ' ✨' : ''}
      </label>
      {children}
    </div>
  );
}
